<p-dialog
  [(visible)]="visible"
  [modal]="true"
  header="Déprogrammer l'événement"
  [style]="{ width: '500px' }"
  (onHide)="hide()"
>
  <div class="p-fluid">
    <div class="mb-3">
      <h3 *ngIf="selectedEvent" class="text-lg font-semibold mb-3">
        {{ selectedEvent.title }}
      </h3>

      <p class="mb-3">
        Veuillez renseigner les informations suivantes pour déprogrammer cet
        événement.
      </p>
    </div>

    <form [formGroup]="unprogramForm" class="flex flex-col gap-4">
      <div class="flex flex-col mb-2">
        <label for="shiftOriginId" class="font-bold mb-2"
          >Origine de la déprogrammation*</label
        >
        <p-select
          id="shiftOriginId"
          formControlName="shiftOriginId"
          [options]="shiftOrigins"
          optionLabel="name"
          optionValue="id"
          placeholder="Sélectionnez une origine"
          styleClass="w-full"
        >
          <ng-template pTemplate="selectedItem" let-origin>
            <div class="flex align-items-center gap-2" *ngIf="origin">
              <span
                class="color-dot"
                [style.background-color]="origin.color"
              ></span>
              <div>{{ origin.name }}</div>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-origin>
            <div class="flex align-items-center gap-2">
              <span
                class="color-dot"
                [style.background-color]="origin.color"
              ></span>
              <div>{{ origin.name }}</div>
            </div>
          </ng-template>
        </p-select>
        <small
          *ngIf="
            unprogramForm.get('shiftOriginId')?.invalid &&
            unprogramForm.get('shiftOriginId')?.touched
          "
          class="p-error mt-1"
        >
          Veuillez sélectionner une origine.
        </small>
      </div>

      <div class="flex flex-col">
        <label for="reason" class="font-bold mb-2"
          >Motif de déprogrammation</label
        >
        <textarea
          id="reason"
          pInputTextarea
          formControlName="reason"
          [rows]="4"
          placeholder="Facultatif: Vous pouvez saisir un motif de déprogrammation"
          class="w-full"
        ></textarea>
      </div>
    </form>

    <div *ngIf="loadingShiftOrigins" class="flex justify-content-center mt-3">
      <p-progressSpinner
        [style]="{ width: '30px', height: '30px' }"
        strokeWidth="4"
      ></p-progressSpinner>
      <span class="ml-2">Chargement des origines...</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        label="Annuler"
        icon="pi pi-times"
        class="p-button-text"
        [disabled]="submitting"
        (click)="hide()"
      ></button>
      <button
        pButton
        label="Déprogrammer"
        icon="pi pi-check"
        [loading]="submitting"
        [disabled]="unprogramForm.invalid || loadingShiftOrigins || submitting"
        (click)="submit()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
